 import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'

class IncentiveUpdateReasonsList extends Component {
  componentDidMount() {
    this.props.dispatch({ type: 'FETCH_INCENTIVE_UPDATE_REASONS_REQUESTED' })
  }

  render() {
    const options = (this.props.incentiveUpdateReasonsList || [])
      .sort((a, b) => a.id - b.id) 
      .map(reason => ({
          value: reason.code,
          label: reason.display
      }))
    const selectedOption = options.find(option => option.value === this.props.selectedReason)

    return (
      <div className="incentive-update-reasons-list"> 
        <Select
          closeOnSelect={true}
          searchable={false}
          clearable={false}
          options={options}
          value={selectedOption}
          className="incentive-update-reasons-select"
          onChange={this.props.onChange}
          placeholder="Please select a reason"
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({ incentiveUpdateReasonsList: state.incentiveUpdateReasonsReducer.incentiveUpdateReasonsList })

export default connect(mapStateToProps)(IncentiveUpdateReasonsList)